import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, emailObfuscated, emailMailto } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  width: 100%;
  max-width: min(37.5rem, 100%);
  margin: 0 auto clamp(3.125rem, 8vw, 6.25rem);
  text-align: center;

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--heading-accent);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }

  .email-note {
    margin-top: 24px;
    color: var(--text-secondary);
    font-size: var(--fz-sm);
    font-family: var(--font-mono);
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion || !sr) {
      return undefined;
    }

    const el = revealContainer.current;
    if (el) {
      sr.reveal(el, srConfig());
    }

    return () => {
      if (sr && el) {
        sr.clean(el);
      }
    };
  }, [prefersReducedMotion]);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading overline">What’s Next?</h2>

      <h2 className="title">Get In Touch</h2>

      <p className="email-note">{emailObfuscated}</p>

      <a className="email-link" href={emailMailto()}>
        Say Hello
      </a>
    </StyledContactSection>
  );
};

export default Contact;
